import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// Components
import { Avatar, Clickable, Col, Icon, Row, Spinner2, Text } from 'components';
import { Caption, Images } from 'components/Post/components';

// Utils
import { getCalculatedText, isDeviceIOS, useOutsideClick } from 'core';
import { Api, normalizeDate, theme } from 'lib';

const SharedShoutout = ({ shoutoutId, user, handleClose }) => {
  const { t } = useTranslation();
  const shoutoutRef = useRef(null);
  const { isMobile } = useSelector((state) => state.appState);
  const [shoutout, setShoutout] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const shoutoutSender = shoutout?.from;
  const shoutoutReceiver = shoutout?.user;
  const isLoggedIn = !!user;

  useOutsideClick(shoutoutRef, handleClose, ['reactionsContainer', 'mediaNavigator', 'arrows']);

  const fetchShoutoutDetails = async () => {
    setIsLoading(true);
    try {
      const res = await Api.get(`/shoutouts/getOne/${shoutoutId}`);
      if (!res) {
        return;
      }

      const calcText = await getCalculatedText(res.comment);
      setShoutout({ ...res, calculatedText: calcText, caption: res.comment });
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchShoutoutDetails();
  }, []);

  if (isLoading)
    return (
      <Col wid="100%" ht="calc(100vh - 74px)" noFlex centerAll>
        <Spinner2 col={theme.SECONDARY} />
      </Col>
    );

  return (
    <>
      <Col
        pos={isDeviceIOS() ? '' : 'fixed'}
        left="0"
        top={0}
        zIndex={3}
        wid="100%"
        ht={'80vh'}
        bg="rgba(47, 47, 47, 0.8)"
      >
        <Clickable
          onClick={handleClose}
          wid={isMobile ? '90vw !important' : '936px !important'}
          ht={isDeviceIOS() ? 0 : '40px'}
          marg={
            isMobile && !isDeviceIOS()
              ? '-32px auto 12px auto'
              : isMobile
                ? '0'
                : '0 auto 12px auto'
          }
          zIndex={9999}
          style={{
            position: 'relative'
          }}
        >
          <Row
            pos={'absolute'}
            // pos={isDeviceIOS() ? 'absolute' : 'fixed'}
            right={isDeviceIOS() ? '14px' : '0'}
            top={isDeviceIOS() ? '14px' : '0'}
            pad="10px"
            hasRadius="32px"
            hasBorder="2px solid #fff"
          >
            <Icon type="close" col="#fff" dimensions={14} />
          </Row>
        </Clickable>

        <Row
          borderBox
          column={isMobile}
          overflow="scroll"
          hasRadius={isMobile ? '12px' : '24px'}
          wid={'90vw'}
          bg="#fff"
          // ht={!isMobile ? '600px' : isMobile && !isDeviceIOS() ? '85vh' : '600px'}
          ht={'80vh'}
          marg="0 auto"
          maxWid="936px"
          ref={shoutoutRef}
          start
        >
          {/* MEDIA */}
          <Col
            boxSizing="border-box"
            ht={!isMobile ? '100%' : isMobile && !isDeviceIOS() ? '80vh' : '300px'}
            pad={isMobile ? '12px 0' : 0}
            bg="#000"
            style={{
              borderTopLeftRadius: !isMobile ? '24' : 0,
              borderBottomLeftRadius: !isMobile ? '24' : 0
            }}
          >
            {!![shoutout?.media]?.length && (
              <Images data={[shoutout?.media] || []} isMobile={isMobile} />
            )}

            {/* {shoutout?.youtubeId && <Youtube youtubeId={shoutout?.youtubeId} />} */}
            {/* {(shoutout?.metaData?.image || shoutout?.metaData?.icon) && <WebsiteView metaData={shoutout?.metaData} />} */}

            {shoutout?.processing && (
              <Col center>
                <Text col="#fff" c1 bold>
                  {t('post?.beingProcessed')}
                </Text>
              </Col>
            )}
          </Col>

          {/* DETAILS / CAPTION */}
          <Col ht="100%" between wid="100%">
            {/* HEADER */}
            <Row
              column={isMobile}
              center={!isMobile}
              gap={isMobile ? '12px' : '32px'}
              start
              borderBottom={`1px solid ${theme.GREY_20}`}
              pad="24px 24px"
            >
              {/* SENDER */}
              <Row>
                <Avatar user={shoutoutSender} small />

                <Col marg="0 0 0 8px" center gap="2px">
                  <Text b2 bold>
                    {shoutoutSender?.name}
                  </Text>

                  <Text c1 med col={theme.GREY_60}>
                    {normalizeDate(shoutout?.createdAt, 'Default', t)}
                  </Text>
                </Col>
              </Row>

              <Text b2 weight="700" marg={isMobile ? '0 0 0 11px' : 0}>
                to{' '}
              </Text>

              {/* RECEIVER */}
              <Row>
                <Avatar user={shoutoutReceiver} small />

                <Col marg="0 0 0 8px" center gap="2px">
                  <Text b2 bold>
                    {shoutoutReceiver?.name}
                  </Text>
                </Col>
              </Row>
            </Row>

            <Col
              wid="calc(100% - 48px)"
              start
              pad="8px 24px"
              ht="703px"
              style={{ overflowY: 'scroll' }}
            >
              <Caption post={shoutout} handleClose={handleClose} />
            </Col>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default SharedShoutout;
